import { Component, Renderer2, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-what-is-artificial-general-intelligence-agi',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './what-is-artificial-general-intelligence-agi.component.html',
  styleUrl: './what-is-artificial-general-intelligence-agi.component.scss'
})
export class WhatIsArtificialGeneralIntelligenceAgiComponent implements OnInit, OnDestroy {
  constructor(private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  private jsonLdScript: any;
  ngOnInit(): void {
    this.injectSchemaMarkup();
  }

  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }

  injectSchemaMarkup(): void {
    const agiSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/artificial-general-intelligence-agi#webpage",
          "url": "https://www.kalpitatechnologies.com/tech-blogs/artificial-general-intelligence-agi",
          "name": "Artificial General Intelligence (AGI): The Future of AI and Intelligent Agents | Kalpita Technologies",
          "description": "Foundational guide explaining what AGI is, how it differs from narrow AI, the rise of intelligent agents, why AGI is the future of AI, its benefits, and challenges and risks.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/artificial-general-intelligence-agi#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com" },
            { "@type": "ListItem", "position": 2, "name": "Blog Index", "item": "https://www.kalpitatechnologies.com/tech-blogs/blog" },
            { "@type": "ListItem", "position": 3, "name": "AGI Guide", "item": "https://www.kalpitatechnologies.com/tech-blogs/artificial-general-intelligence-agi" }
          ]
        },
        {
          "@type": "BlogPosting",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/artificial-general-intelligence-agi#article",
          "headline": "Artificial General Intelligence (AGI): The Future of AI and Intelligent Agents",
          "articleBody": "In recent years, Artificial Intelligence has become a part of everyday life... AGI refers to a form of AI capable of human-like adaptability, reasoning, and continuous learning...",
          "author": { "@type": "Person", "name": "Grace Catharine" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2025-05-30",
          "image": "https://www.kalpitatechnologies.com/assets/resources/blog/artificial-general-intelligence/agi-banner-image.webp"
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/artificial-general-intelligence-agi#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What is Artificial General Intelligence (AGI)?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Artificial General Intelligence (AGI) is a form of AI capable of human-like understanding, learning, and problem-solving across many different tasks and domains."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(agiSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
}
